import { InjectionToken } from '@angular/core';
import { PitchPlaylistSong } from 'projects/pitch/src/app/shared/pitch-playlist/state/pitch-playlist.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Recording } from 'src/app/recordings/state';
import { SyncPlayerStrategy } from './music.service';
import { ESongPlaybackSource } from './enums';

export const PLAYLIST_MUSIC_SERVICE = new InjectionToken<IPlaylistMusicService>('IPlaylistMusicService');

export interface IPlaylistMusicService {
  playlist$: Subject<any> | Observable<any>;
  activeSong$: Subject<Recording> | Observable<Recording>;
  playlistPanelOpened$: Subject<boolean> | Observable<boolean>;

  setActiveSong(song: Recording | PitchPlaylistSong): void;
  getActiveSong(): Recording;

  togglePlaylistPanel(): void;
}

export interface IPlayingProgress {
  recording: Recording;
  progress: number;
}
export const LINK_LIFE_TIME = 900000;
export const EXPIRATION_DIFF_TIME = 10000;

export interface IPlayer {
  playing: Observable<Recording>;
  pausing: Observable<Recording>;
  linkLifeTimer: Observable<number>;
  progress: Subject<IPlayingProgress>;
  error: Subject<Error>;
  loading: Subject<string>;
  playingTime: Subject<number>;
  trackDuration: BehaviorSubject<number>;

  play(): void;
  pause(): void;
  seek(time: number): void;
  isPlaying(): boolean;
  stop(): void;

  playPause(): void;

  setRecording(recording: Recording): void;
  getRecording(): Recording;
  getProgress(): number;

  getPlayingTime(): number;
  getLinkTime(): number;

  load(trackLink: string): void;
  unload(): void;

  duration(): number;

  reject(): void;
}

export interface ISongUpdate {
  recording: Recording;
  type: 'playlist' | 'playback';
  source?: ESongPlaybackSource;
  sourceStrategy?: SyncPlayerStrategy;
  projectId?: number;
}
